module.exports = __webpack_public_path__ + "static/TeamAugNoShadow-23d9b4944695bc7b507f835d036de7b6.png";